import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { OfferReadOnlyButton } from "../../components/buttons/OfferReadOnlyButton";
import { useDialogBetter } from "../../hooks/useDialogBetter";
import { useGenerateOfferDraftMutation } from "../../services/draftsService";
import { OfferCreateDialog, OfferEditDialog } from "./OfferDialogs";
import OfferFiascoDialog from "./OfferFiascoDialog";

export default function OfferManageDialog({ open, onClose, offer, refreshOffers }) {
    const { t } = useTranslation();
    const { openDialog } = useDialogBetter();
    const { openDialog: openCreateOfferDialog } = useDialogBetter();
    const isOfferStatusFailure = offer?.status?.status_key ==="Failure"

    const handleFiasco = () => {
        openDialog({
            Component: OfferFiascoDialog,
            componentProps: {
                offerId: offer.id,
                onSuccess: onClose,
            },
        });
    };

    const handleEdit = () => {
        openDialog({
            Component: OfferEditDialog,
            componentProps: {
                initialOffer: offer,
                onSuccess: () => {
                    refreshOffers();
                    onClose();
                },
                onCloseAlways: () => {
                    onClose();
                },
            },
        });
    };

    const handleCreateNewOfferFromContext = () => {
        const initialProducts = offer.products.map((product) => ({
            productId: product.product.id,
            discountPercent: product.discount_percent,
        }));

        openCreateOfferDialog({
            Component: OfferCreateDialog,
            componentProps: {
                initialCustomerIds: offer.customers.map((c) => c.customer.id),
                initialProducts: initialProducts,
            },
        });
    };

    const handleDummy = () => {
        alert("Not implemented yet");
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>{t("offers.manageDialog.title")}</DialogTitle>
            <DialogContent>
                <Grid container direction="column" spacing={2} sx={{ mt: 1 }}>
                    <Grid item>
                        <Button variant="contained" fullWidth onClick={handleEdit}>
                            {t("offers.manageDialog.editOffer")}
                        </Button>
                    </Grid>
                    <Grid item>
                        <OfferReadOnlyButton offerId={offer.id} variant="contained" fullWidth />
                    </Grid>
                    <Grid item>
                        <Button
                            variant="contained"
                            fullWidth
                            onClick={handleCreateNewOfferFromContext}
                        >
                            {t("offers.manageDialog.createNewOffer")}
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button variant="contained" color="error" fullWidth onClick={handleFiasco} disabled={isOfferStatusFailure}>
                            {t("offers.manageDialog.fiasco")}
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button variant="contained" fullWidth onClick={handleDummy}>
                            {t("offers.manageDialog.arrangement")}
                        </Button>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t("close")}</Button>
            </DialogActions>
        </Dialog>
    );
}

const PreviewButton = (props) => {
    const { offer, onClose } = props;
    const { t } = useTranslation();

    const { mutate: generatePdf } = useGenerateOfferDraftMutation({
        onSuccess: (response) => {
            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            window.open(url, "_blank");
            setTimeout(() => URL.revokeObjectURL(url), 1000);
        },
    });

    const handlePreview = () => {
        generatePdf({
            draftId: offer.draft_id,
            requestBody: { offer_id: offer.id },
        });
        onClose();
    };

    return (
        <Button onClick={handlePreview} disabled={!offer.draft_id} variant="contained" fullWidth>
            {t("offers.manageDialog.previewOffer")}
        </Button>
    );
};
